import React, { useRef, useState } from "react";
import { ScrollView, Text, TouchableOpacity, View } from "react-native";
import { FlatList } from "react-native-gesture-handler";
import { connect } from "react-redux";
import { setUserFilter } from "../actions/filter";
import { STYLES } from "../assets/styles";
import { SCREEN_WIDTH } from "../common";
import Container from "../components/Container";
import CustomButton from "../components/CustomButton";

function Launch({ navigation, filterOptions, setUserFilter }) {
  const listRef = useRef();
  const [selectedData, setSelectedData] = useState({
    class: null,
    catagories: {},
  });

  const handleOnNext = () => {
    setUserFilter({
      itemsFilter: selectedData,
    });
  };

  const handleGenderSelect = (name) => {
    setSelectedData({
      class: name,
      catagories: {},
    });
    listRef.current.scrollToIndex({ animated: true, index: 1 });
  };

  const catagoryItems = filterOptions.catagories[selectedData.class] || [];

  const Item = ({ text, selected, onPress = () => {} }) => (
    <TouchableOpacity onPress={onPress}>
      <View
        style={{
          margin: 10,
          padding: 15,
          minWidth: 80,
          borderWidth: 2,
          borderColor: selected
            ? STYLES.colors.purpel
            : STYLES.colors.lightFontColor,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 5,
          backgroundColor: selected
            ? STYLES.colors.purpel + "30"
            : STYLES.colors.white,
        }}
      >
        <Text
          style={{
            color: selected
              ? STYLES.colors.purpel
              : STYLES.colors.lightFontColor,
          }}
        >
          {text}
        </Text>
      </View>
    </TouchableOpacity>
  );

  const options = [
    {
      content: (
        <View style={{ width: "100%", alignItems: "center" }}>
          <Text>Select any one</Text>
          <View
            style={{
              flexDirection: "row",
              paddingTop: 10,
            }}
          >
            <Item
              key="1s"
              text="Men"
              selected={selectedData.class === "Men"}
              onPress={() => handleGenderSelect("Men")}
            />
            <Item
              key="1m"
              text="Women"
              selected={selectedData.class === "Women"}
              onPress={() => handleGenderSelect("Women")}
            />
          </View>
        </View>
      ),
    },
    {
      content: (
        <View style={{ justifyContent: "center", alignItems: "center" }}>
          <Text>Select one or more</Text>
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "flex-end",
              // height: "10%",
              paddingBottom: 30,
            }}
          >
            {catagoryItems.map((name, index) => (
              <Item
                key={index + "s"}
                text={name}
                selected={selectedData["catagories"][name]}
                onPress={() => {
                  let updated = { ...selectedData };
                  if (updated["catagories"][name] === undefined) {
                    updated["catagories"][name] = 1;
                  } else {
                    delete updated["catagories"][name];
                  }
                  setSelectedData(updated);
                }}
              />
            ))}
          </View>
        </View>
      ),
    },
  ];

  return (
    <Container>
      <View style={{ flex: 1 }}>
        <FlatList
          horizontal
          keyExtractor={(_, index) => index + "oi"}
          scrollEnabled={false}
          showsHorizontalScrollIndicator={false}
          ref={(ref) => (listRef.current = ref)}
          data={options}
          contentContainerStyle={{
            justifyContent: "center",
            alignItems: "center",
          }}
          renderItem={({ item: { content }, index }) => (
            <View
              key={index + "oi"}
              style={{ width: SCREEN_WIDTH, padding: 15 }}
            >
              {content}
            </View>
          )}
        />
      </View>
      <View style={{ alignItems: "flex-end", justifyContent: "space-between" }}>
        <CustomButton
          rightIcon={{
            type: "AntDesign",
            name: "right",
            style: { padding: 25 },
          }}
          disabled={Object.keys(selectedData["catagories"]) < 1}
          onPress={handleOnNext}
          text="Next"
        />
      </View>
    </Container>
  );
}
const mapStateToProps = (state) => ({
  filterOptions: state.filter.options,
});
const mapDispatchToProps = (dispatch) => ({
  setUserFilter: (data) => dispatch(setUserFilter(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Launch);
